"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
require("./styles.scss");
const Toast = (props) => {
    const { children, refresher, delay = 2000, text } = props;
    const [isVisible, setIsVisible] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!refresher) {
            return;
        }
        setIsVisible(true);
        const timeoutCode = setTimeout(() => {
            setIsVisible(false);
        }, delay);
        return () => {
            clearTimeout(timeoutCode);
        };
    }, [refresher]);
    return (React.createElement("div", { className: "c-toast" },
        children,
        React.createElement("div", { className: `c-toast__message c-toast__message--${isVisible ? "visible" : ""}` }, text)));
};
exports.Toast = Toast;
